<template>
  <span
    :class="containerKls"
    data-component-name="Tag"
    data-event-name="checked"
    :data-event-content="props.checked ? '选中' : '未选中'"
    @click="handleChange"
  >
    <slot />
  </span>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { CHANGE_EVENT } from '@jdesign-vue/constants'
import { useNamespace } from '@jdesign-vue/hooks'
import { checkTagEmits, checkTagProps } from './check-tag'

defineOptions({
  name: 'JdCheckTag',
})
const props = defineProps(checkTagProps)
const emit = defineEmits(checkTagEmits)

const ns = useNamespace('check-tag')
const containerKls = computed(() => [ns.b(), ns.is('checked', props.checked)])

const handleChange = () => {
  const checked = !props.checked
  emit(CHANGE_EVENT, checked)
  emit('update:checked', checked)
}
</script>
